import { render, staticRenderFns } from "./PortfolioListRow.vue?vue&type=template&id=83f6b16a&"
import script from "./PortfolioListRow.vue?vue&type=script&lang=js&"
export * from "./PortfolioListRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports